import { reactive } from 'vue';
import { setCookie, deleteCookie } from '../../functions';

const channel = new BroadcastChannel('session-sync');

const TAB_ID = Math.random().toString(36).substring(2, 15);
const key = 'member';

channel.onmessage = (event) => {
    const { key, value, action, senderTabId } = event.data;
    if (action === 'set') {
        sessionStorage.setItem(key, value);
    } else if (action === 'remove') {
        sessionStorage.removeItem(key);
    }
    if (senderTabId === TAB_ID) return;
    window.dispatchEvent(new CustomEvent('memberChanged', { detail: { user: value ? JSON.parse(value) : {} } }));
};

export const userStore = reactive({
    loggedIn: false,
    user: {
        name: {
            givenname: '',
            surname: '',
        },
        phone: '',
        activeSubscription: {
            subscriptionId: ''
        },
        favouriteVodItems: []
    },
    updateUser(user) {
        if (!user.name) {
            user.name = {
                givenname: '',
                surname: '',
            }
        }

        if (!user.activeSubscription) {
            user.activeSubscription = {
                subscriptionId: ''
            }
        }
        Object.assign(this.user, user);
        this.loggedIn = true;
        const value = JSON.stringify(this.user);
        sessionStorage.setItem(key, value);
        setCookie('memberCheck', 'true', 1 / 144);
        channel.postMessage({ key, value, action: 'set', senderTabId: TAB_ID })
    },
    deleteUser() {
        Object.assign(this.user, { favouriteVodItems: [] });
        this.loggedIn = false;
        sessionStorage.removeItem('member');
        deleteCookie('memberCheck');
        channel.postMessage({ key, action: 'remove', senderTabId: TAB_ID })
    }
});